module.exports = __webpack_public_path__ + "static/img/zytz_jcjg_icon.png";